import {omneticApi} from '@dms/api/base';

import {
  GetVehicleSelectionAttributesApiResponse,
  GetVehicleSelectionAttributesApiResponseSchema,
  PreviewPromotionalPhotoVehicleSelectionApiArg,
  PreviewPromotionalPhotoVehicleSelectionApiResponse,
  PreviewWatermarkVehicleSelectionApiArg,
  PreviewWatermarkVehicleSelectionApiResponse,
  VehicleSelectionPreviewResponseBodySchema,
} from './types';

export const vehicleSelectionApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicleSelectionAttributes: build.query<GetVehicleSelectionAttributesApiResponse, void>({
      query: () => ({
        url: `/dms/v1/vehicle-selection/attributes`,
      }),
      extraOptions: {
        responseSchema: GetVehicleSelectionAttributesApiResponseSchema,
      },
    }),
    // A mutation rather than a query: computed on demand from the whole draft in the body and never
    // re-fetched automatically (same as the financing promo preview). It changes nothing on the BE.
    previewPromotionalPhotoVehicleSelection: build.mutation<
      PreviewPromotionalPhotoVehicleSelectionApiResponse,
      PreviewPromotionalPhotoVehicleSelectionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/promotional-photo/vehicle-selection/preview`,
        method: 'POST',
        body: queryArg.previewPromotionalPhotoVehicleSelectionRequestBody,
      }),
      extraOptions: {
        responseSchema: VehicleSelectionPreviewResponseBodySchema,
      },
    }),
    // The same read-only preview for a watermark draft; the response has the same shape.
    previewWatermarkVehicleSelection: build.mutation<
      PreviewWatermarkVehicleSelectionApiResponse,
      PreviewWatermarkVehicleSelectionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/watermark/vehicle-selection/preview`,
        method: 'POST',
        body: queryArg.previewWatermarkVehicleSelectionRequestBody,
      }),
      extraOptions: {
        responseSchema: VehicleSelectionPreviewResponseBodySchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVehicleSelectionAttributesQuery,
  usePreviewPromotionalPhotoVehicleSelectionMutation,
  usePreviewWatermarkVehicleSelectionMutation,
} = vehicleSelectionApi;
